'use client'

import React from 'react'
import { usePathname, useRouter } from 'next/navigation'
import styles from './NavItem.module.css'

export interface NavItemProps {
  label: string
  href: string
  /** 기본값: href가 '/'면 exact, 그 외 prefix */
  match?: 'exact' | 'prefix'
  /** 상태 (기본값: pathname 기반 자동 계산) */
  status?: 'default' | 'hover' | 'pressed'
  onClick?: () => void
}

export default function NavItem({
  label,
  href,
  match,
  status,
  onClick,
}: NavItemProps) {
  const router = useRouter()
  const pathname = usePathname()

  const resolvedMatch: 'exact' | 'prefix' = match ?? (href === '/' ? 'exact' : 'prefix')
  const isActive =
    resolvedMatch === 'exact'
      ? pathname === href
      : pathname === href || pathname.startsWith(href + '/')

  const finalStatus = status ?? (isActive ? 'pressed' : 'default')

  return (
    <div
      data-status={finalStatus}
      className={`${styles.navItem} ${finalStatus === 'pressed' ? styles.pressed : ''}`}
      onClick={() => {
        onClick?.()
        router.push(href)
      }}
      aria-current={isActive ? 'page' : undefined}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
          router.push(href)
        }
      }}
    >
      <div className={styles.navItemText}>{label}</div>
    </div>
  )
}
